type IdleCallback = () => void;

/**
 * Run `cb` once the browser is idle.
 *
 * Uses `requestIdleCallback` with a 2-second timeout so the callback also
 * fires on busy pages within a bounded delay. Safari ≤16 doesn't implement
 * RIC — falls back to a short `setTimeout` (default 0ms) which yields to
 * first paint without the RIC heuristics.
 */
export const deferIdle = (cb: IdleCallback, fallbackDelayMs = 0): void => {
  const ric = (window as unknown as Record<string, unknown>).requestIdleCallback as
    | typeof window.requestIdleCallback
    | undefined;
  if (typeof ric === 'function') {
    ric(cb, { timeout: 2000 });
  } else {
    setTimeout(cb, fallbackDelayMs);
  }
};
